// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"a9ef8eb0","453":"7b08b113","553":"26d92680","977":"bda3df31"}[chunkId] + ".chunk.js";
};